module.exports = __webpack_public_path__ + "img/new-footterLogo.8a249253.png";